<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="$t('用户名称')">
              <a-input v-model="queryParams.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('应用')">
              <a-select v-model="queryParams.appId" :options="appOptions" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="users" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleEditPassword(record)">{{ $t('设置密码') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleEditRole(record)">{{ $t('设置角色') }}</a>    
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <UserEditModal ref="edit" @ok="handleRefresh" />
    <UserEditPasswordModal ref="password" />
    <UserEditRoleModal ref="role" @ok="handleRefresh" />
  </a-card>
</template>
<script>
import { getUserList, removeUser } from '@/api/user/user'
import UserEditModal from './modals/UserEditModal.vue'
import UserEditPasswordModal from './modals/UserEditPasswordModal.vue'
import UserEditRoleModal from './modals/UserEditRoleModal.vue'
import { getAppListForCurrentUser } from '@/api/app/app'

export default {
  components: {
    UserEditModal,
    UserEditPasswordModal,
    UserEditRoleModal
  },
  data() {
    return {
      queryParams: {},
      users: [],
      appOptions: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('用户名称'),
          dataIndex: 'userName',
          width: 200
        },
        {
          title: this.$t('登录账号'),
          dataIndex: 'loginName',
        },
        {
          title: this.$t('角色'),
          dataIndex: 'roles',
          customRender: (text, record) => {
            const roles = record.roles || []
            return roles.map(e => e.name).join(',') || ''
          }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  mounted() {
    this.handleRefresh()
    this.loadOptions()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getUserList({ ...params }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.users = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleAdd() {
      this.$refs.edit.show()
    },
    handleEdit(record) {
      this.$refs.edit.show(record)
    },
    handleEditRole(record) {
      this.$refs.role.show(record)
    },
    handleEditPassword(record) {
      this.$refs.password.show(record)
    },
    handleDelete(record) {
      removeUser([record.id]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" module>
.container {
  height: 100%;
  padding: 20px;
}
</style>